"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _findDOMNode = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/findDOMNode"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _class, _class2, _temp;

var styles = {
  componentId: 'dXATK',
  template: function template(theme) {
    return "\n\n.dXATK_bGBk{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;cursor:pointer;font-family:".concat(theme.fontFamily || 'inherit', ";font-size:").concat(theme.fontSize || 'inherit', ";font-weight:").concat(theme.fontWeight || 'inherit', ";line-height:").concat(theme.lineHeight || 'inherit', ";user-select:none}\n\n.dXATK_bGBk[aria-disabled],.dXATK_bGBk[aria-selected]{cursor:default}\n\n.dXATK_bGBk[aria-disabled]{opacity:0.5}\n\n.dXATK_bGBk:focus{outline:none}\n\n.dXATK_GKUc,.dXATK_cAug{order:-1;white-space:nowrap}\n\n.dXATK_cAug{border:0.0625rem solid transparent;border-top-left-radius:0.1875rem;border-top-right-radius:0.1875rem;box-sizing:border-box;color:").concat(theme.simpleColor || 'inherit', ";margin-bottom:-0.0625rem;margin-right:0.2em;padding:0.7em 1em}\n\n.dXATK_cAug:first-of-type{margin-left:0}\n\n.dXATK_cAug:not([aria-selected]):not([aria-disabled]):hover,.dXATK_cAug[aria-selected]{background:").concat(theme.simpleSelectedBackground || 'inherit', ";border-color:").concat(theme.simpleSelectedBorderColor || 'inherit', "}\n\n.dXATK_cAug:hover,.dXATK_cAug[aria-disabled],.dXATK_cAug[aria-selected]{color:").concat(theme.simpleSelectedColor || 'inherit', "}\n\n.dXATK_cAug[aria-selected]{border-bottom-color:").concat(theme.simpleSelectedBackground || 'inherit', ";z-index:1}\n\n.dXATK_cAug:focus{text-decoration:underline}\n\n.dXATK_GKUc{color:").concat(theme.minimalColor || 'inherit', ";line-height:1;padding:1rem 1.25rem;position:relative;z-index:1}\n\n.dXATK_GKUc:after{bottom:-0.0625rem;content:\"\";height:0.25rem;left:0;opacity:0;position:absolute;transform:translateZ(0) scaleX(0.01);transition:all 0.2s ease-out;width:100%}\n\n.dXATK_GKUc[aria-disabled]{font-weight:400}\n\n.dXATK_GKUc:not([aria-selected]):not([aria-disabled]):hover{border-bottom-color:").concat(theme.minimalHoverBorderColor || 'inherit', "}\n\n.dXATK_GKUc[aria-selected]:after{background-color:").concat(theme.minimalSelectedBorderColor || 'inherit', ";opacity:1;transform:translateZ(0) scaleX(1)}\n\n.dXATK_GKUc:focus{text-decoration:underline}\n\n.dXATK_bNyY{border:0;clip:rect(0 0 0 0);height:0.0625rem;margin:-0.0625rem;overflow:hidden;padding:0;position:absolute;width:0.0625rem}");
  },
  'root': 'dXATK_bGBk',
  'minimal': 'dXATK_GKUc',
  'simple': 'dXATK_cAug',
  'screenreader-only': 'dXATK_bNyY'
};
var Tab = (
/**
---
parent: TabList
---
**/
_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Tab, _Component);

  function Tab() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Tab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Tab)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClick = function (e) {
      if (_this.props.disabled) {
        return;
      }

      _this.props.onClick(_this.props.index, e);
    };

    _this.handleKeyDown = function (e) {
      if (_this.props.disabled) {
        return;
      }

      _this.props.onKeyDown(_this.props.index, e);
    };

    return _this;
  }

  (0, _createClass2.default)(Tab, [{
    key: "syncNodeAttributes",
    value: function syncNodeAttributes(node, props) {
      if (props.selected) {
        node.setAttribute('tabindex', 0);

        if (props.focus) {
          node.focus();
        }
      } else if (!props.disabled) {
        node.setAttribute('tabindex', -1);
      } else {
        node.removeAttribute('tabindex');
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncNodeAttributes((0, _findDOMNode.default)(this), this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.syncNodeAttributes((0, _findDOMNode.default)(this), this.props);
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      return _react.default.createElement("span", {
        className: styles.icon,
        "aria-hidden": "true",
        "aria-label": ""
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classes;

      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles[this.props.variant], true), _classes);
      var icon = this.props.variant !== 'screenreader-only' && this.renderIcon();
      /* eslint-disable jsx-a11y/onclick-has-focus, jsx-a11y/no-static-element-interactions */

      return _react.default.createElement("div", {
        className: (0, _classnames.default)(classes),
        role: this.props.role,
        id: this.props.id,
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        "aria-selected": this.props.selected ? 'true' : null,
        "aria-disabled": this.props.disabled ? 'true' : null,
        "aria-hidden": this.props.role === 'presentation' ? 'true' : null,
        "aria-controls": this.props.controls
      }, icon, this.props.children);
      /* eslint-enable jsx-a11y/onclick-has-focus, jsx-a11y/no-static-element-interactions */
    }
  }]);
  Tab.displayName = "Tab";
  return Tab;
}(_react.Component), _class2.propTypes = {
  variant: _propTypes.default.oneOf(['simple', 'minimal', 'screenreader-only']),
  id: _propTypes.default.string.isRequired,
  index: _propTypes.default.number.isRequired,
  controls: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  focus: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  role: _propTypes.default.string,
  children: _propTypes.default.node
}, _class2.defaultProps = {
  children: null,
  variant: 'simple',
  disabled: false,
  selected: false,
  focus: false,
  role: 'tab',
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {}
}, _temp)) || _class) || _class);
exports.default = Tab;